// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .under-construction {
    font-weight: bold;
    color: #ff6f61;
    background-color: #5a6d85;
    padding: 16px;
    border-radius: 8px;
  }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"EAAE;IACE,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB","sourcesContent":["  .under-construction {\n    font-weight: bold;\n    color: #ff6f61;\n    background-color: #5a6d85;\n    padding: 16px;\n    border-radius: 8px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
